<template>
	<button
		@click="$emit('click')"
		class="custom-button v-btn"
		:class="customClass"
		:style="{ minWidth }"
		:disabled="disabled"
	>
		<slot />
	</button>
</template>

<script>
export default {
	name: 'PButton',
	props: {
		type: {
			default: () => 'primary',
			validator: value => ['primary', 'secondary', 'black'].includes(value),
		},
		extended: {
			default: () => false,
		},
		outlined: {
			default: () => false,
		},
		disabled: {
			default: () => false,
		},
		minWidth: {
			default: () => 'auto',
		},
		roundedLevel: {
			default: () => 'rounded-full',
			validator: value => ['rounded', 'rounded-full'].includes(value),
		},
		size: {
			default: 'normal',
			validator: value => ['xsmall', 'small', 'normal', 'large'].includes(value),
		},
	},
	computed: {
		customClass() {
			return [
				{
					primary: this.type === 'primary',
					secondary: this.type === 'secondary',
					black: this.type === 'black',
					outlined: this.outlined,
				},
				this.extended ? 'custom-button--px-14' : 'custom-button--px-8',
				this.roundedLevel === 'rounded' ? 'custom-button-rounded' : '',
				this.roundedLevel === 'rounded-full' ? 'custom-button-rounded-full' : '',
				this.size === 'xsmall' ? 'v-btn--xsmall custom-button--xsmall' : '',
				this.size === 'small' ? 'v-btn--small custom-button--small' : '',
				this.size === 'large' ? 'v-btn--large custom-button--large' : '',
				this.disabled ? 'v-btn--disabled' : '',
			];
		},
	},
};
</script>

<style lang="scss" scoped>
.custom-button {
	&--px-8 {
		padding-left: 2rem !important;
		padding-right: 2rem !important;
	}
	&--px-14 {
		padding-left: 3.5rem !important;
		padding-right: 3.5rem !important;
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/shared/components/ui/p-button.vue